export enum ToastMessageTriggers {
    OPEN_CONVERSATIONS = 'OPEN_CONVERSATIONS_TAB',
}
